export default __webpack_public_path__ + "static/media/cert8.683a6a5b.jpg";